<div class="footer-container px-6 flex justify-content-center flex-column">
    <div class="footer-content mx-6 my-5 flex flex-column flex-wrap" *ngIf="expanded" #footerContent>
        <div class="content-1 flex flex-column">
            <!-- <p>Any individuals depicted on this web page are actors and not actual health care providers or patients. <br>User Profile Information listed on the Graphical User Interfaces are fictitious examples only and do not
                contain any actual user data.</p>
            <div class="flex">
                <p>You are encouraged to report negative side effects or quality complaints of prescription drugs to the FDA. Visit www.fda.gov/medwatch or call  &nbsp;</p>
                <p class="font-semibold">1-800-FDA-1088</p>
                <p>.</p>
            </div> -->
            <div class="flex">
                <p class="font-semibold">© 2020-{{currentYear}} Bayer </p>
                <p class="mx-3">|</p>
                <p>This material may not be reproduced, displayed, modified or distributed without the express prior written consent of Bayer.</p>
            </div>
        </div>
        <p-divider type="solid"></p-divider>
        <div class="content-2 flex flex-column">
            <!-- <p>BAYER, the Bayer Cross, PassLink, MEDRAD Stellant, MEDRAD Centargo, MEDRAD MRXperion, MEDRAD Stellant FLEX, MEDRAD Intego, MEDRAD, Stellant, MRXperion, Stellant FLEX, DirectCARE, PartnerCARE, VirtualCare, SelectCARE, and TechCARE are trademarks owned by and/or registered to Bayer in the U.S. and/or other countries.</p> -->
            <!-- <p>Bayer HealthCare LLC 100 Bayer Boulevard, PO Box 915, Whippany, NJ 07981</p> -->
            <p>Bayer Medical Care, Inc. 1 Bayer Drive, Indianola, PA-15051</p>
        </div>

        <p-divider type="solid"></p-divider>
        <div class="last-updated">
            <p>Last update: {{lastUpdated}}</p>
        </div>
    </div>

    <div class="footer-header-container flex mx-6 py-2">
        <div class="copyright">© 2020-{{currentYear}} Bayer</div>
        <div class="legal-disclaimer mx-3">Legal Disclaimers</div>
        <div class="expand-control-container">
            <i class="control-icon pi" [ngClass]="expanded ? 'pi-chevron-up' : 'pi-chevron-down'"
                (click)="toggleFooter()">
            </i>
        </div>
    </div>
</div>
